module.exports = __webpack_public_path__ + "static/media/help.0a3f2671.svg";